import {call, put, takeLatest, select} from 'redux-saga/effects';
import {delay} from 'redux-saga';
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import {showSpinner, hideSpinner} from "../actions/loading.actions"
import {createOrder, payOrder, getOrdersList, getOrderDetails } from '../api/payment.api';
import { CREATE_ORDER, GET_ORDERS_LIST, GET_ORDER_DETAILS, REDIRECT_TO_MOBIL_PAY } from '../actions/types';
import {GENERIC_ERROR_MESSAGE, PAYMENT_GENERIC_ERROR, NOT_AVAILABLE_SEATS} from "../config/messages";
import { createOrderSucceeded, getOrdersListSucceeded, getOrderDetailsSucceeded } from '../actions/payment.actions';
import { redirectToMobilPay } from '../helpers/general.helper';
import { loginApiMessagesShow } from '../actions/user.actions';

function* crateOrderSaga(action){
    try{
        yield put(showSpinner());
    const response = yield call(createOrder, action.payload);
        if(response.status === 200){  
            yield put(hideSpinner()); 
            if(response.data.id[0]['value']){
                const payload = {
                    orderId: response.data.id[0]['value'],
                    firstName: action.payload.first_name,
                    lastName: action.payload.last_name,
                    address: action.payload.address,
                    email: action.payload.email,
                    mobilePhone: action.payload.phone
                }
                yield put(showSpinner());
                const payment = yield call(payOrder, payload)
                if (payment.status === 200){
                    yield put(hideSpinner());
                    redirectToMobilPay(payment.data);
                }
                else {
                    yield put(showGeneralError(PAYMENT_GENERIC_ERROR));
                }
            }
            else {
                yield put(showGeneralError(PAYMENT_GENERIC_ERROR));
            }
        } else {
            yield put(showGeneralError(PAYMENT_GENERIC_ERROR));
        }
    } catch (e) {
        yield put(hideSpinner());
        if( e.message.substr(e.message.length - 3) === '422') {
            yield put(loginApiMessagesShow({error: NOT_AVAILABLE_SEATS}));
        } else {
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    } 
}

function* getOrdersListSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getOrdersList, action.payload);
        if (response.status){
            yield put(hideSpinner());
        }
        if(response.status === 200){   
        yield put(getOrdersListSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getOrderDetailsSaga(action){
    try{
        yield put(showSpinner());
        const response = yield call(getOrderDetails, action.payload);
        if (response.status === 200){
            yield put(hideSpinner());
            yield put(getOrderDetailsSucceeded(response.data));
        }
    }  catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* redirectToMobilPaySaga(action){
    try{
        yield put(showSpinner());
        const payment = yield call(payOrder, action.payload)
        if (payment.status === 200){
            yield put(hideSpinner());
            redirectToMobilPay(payment.data);

        }
        else {
            yield put(showGeneralError(PAYMENT_GENERIC_ERROR));
        }
    } catch (e) {
        yield put(hideSpinner());
        if( e.message.substr(e.message.length - 3) === '422') {
            yield put(showGeneralError(NOT_AVAILABLE_SEATS));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        } else {
            yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
            yield call(delay, 5000);
            yield put(hideGeneralError(''));
        }
    }
}

export default function* paymentSaga(){
    yield takeLatest(CREATE_ORDER, crateOrderSaga);
    yield takeLatest(GET_ORDERS_LIST, getOrdersListSaga);
    yield takeLatest(GET_ORDER_DETAILS, getOrderDetailsSaga);
    yield takeLatest(REDIRECT_TO_MOBIL_PAY, redirectToMobilPaySaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/payment.saga.js